export default __webpack_public_path__ + "static/27767cd11d1414623e8009df65ae7eb7.ttf";